import styled from "styled-components";

export const ModalButtonLayout = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: 2rem;
    justify-content: center;
`;
